module.exports = __webpack_public_path__ + "img/selected_icon-1.8076cf4.png";